import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/features/auth/contexts/AuthContext'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="min-h-screen bg-casino-gradient flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-casino-gold border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-casino-gold font-cinzel">Cargando...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    // Redirect to home with return URL
    return <Navigate to="/" state={{ from: location }} replace />
  }

  return <>{children}</>
}
